<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" :absolute="false" />
    <h2 v-if="showMainTitle" class="mb-5">
      {{ $t('Prašymai dėl juridinių faktų') }}
    </h2>

    <v-row no-gutters>
      <v-col
        v-for="(paslauga, paslaugaIndex) in paslaugosFiltered"
        :key="`paslauga-${paslaugaIndex}`"
        cols="12"
        md="12"
        class="mb-3"
      >
        <template v-if="paslauga.groupH2">
          <h2 class="mt-3 mb-2">
            {{ paslauga.groupTitle
            }}<el-tooltip
              inline
              :tooltip="paslauga.tooltip"
              external
              @activate="
                eventPayload => showAprasymas(eventPayload, paslauga.tooltip)
              "
            />
          </h2>
        </template>
        <template v-if="!paslauga.groupH2">
          <h3 class="mt-3 mb-2">
            {{ paslauga.groupTitle
            }}<el-tooltip
              inline
              :tooltip="paslauga.tooltip"
              external
              @activate="
                eventPayload => showAprasymas(eventPayload, paslauga.tooltip)
              "
            />
          </h3>
        </template>
        <div
          class="paslauga-aprasymas mb-2"
          v-if="paslaugaAprasymas === paslauga.tooltip"
        >
          <el-paslauga-aprasymas
            :key="`paslauga.groupTitle`"
            :tooltip="paslaugaAprasymas"
            @close="hideAprasymas"
          />
        </div>

        <v-card class="ntr-card-gray pt-2 py-2 px-2" flat>
          <v-row no-gutters>
            <v-col
              v-for="prasymas in paslauga.prasymaiList"
              :key="prasymas.key"
              cols="12"
              md="4"
              class="mb-2 px-2 pt-2"
            >
              <el-savitarna-icon
                class="prasymas-icon mr-2"
                :icon="prasymas.icon"
                :title="prasymas.title"
                type="ntrpaslauga"
                :loading="loading"
                @click.native="gotoPrasymas(prasymas)"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'

export default {
  name: 'NtrPrasymai',
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      loading: false,
      paslaugaAprasymas: null,
      zemes_sklypas_ijungtas: false,
    }
  },
  computed: {
    ...mapGetters(['savitarnaRedirect']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    savitarnaPrefix() {
      return `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}`
    },
    savitarnaParams() {
      return ''
    },
    paslaugosList() {
      return [
        {
          groupTitle: this.$t('Šeimos turtas'),
          prasymaiList: [
            {
              meniuId: 141,
              title: this.$t('Įregistravimas'),
              route: 'seimaIregistravimasList',
              icon: 'mdi-bank-outline',
              roles: this.role(['EL_FA']) && !this.role(['EL_JA']),
            },
            {
              meniuId: 142,
              title: this.$t('Perkėlimas'),
              route: 'seimaPerkelimasList',
              icon: 'mdi-bank-transfer',
              roles: this.role(['EL_FA']) && !this.role(['EL_JA']),
            },
            {
              meniuId: 143,
              title: this.$t('Išregistravimas'),
              route: 'seimaIsregistravimasList',
              icon: 'mdi-bank-transfer-out',
              roles: this.role(['EL_FA']) && !this.role(['EL_JA']),
            },
          ],
        },
        {
          groupTitle: this.$t('Bendroji jungtinė sutuoktinių nuosavybė'),
          prasymaiList: [
            {
              meniuId: 144,
              title: this.$t('Įregistravimas'),
              route: 'bendraIregistravimasList',
              icon: 'mdi-account-multiple-check-outline',
              roles: this.role(['EL_FA']) && !this.role(['EL_JA']),
            },
          ],
        },
        {
          groupTitle: this.$t('Nuomos sutartis'),
          prasymaiList: [
            {
              meniuId: 145,
              title: this.$t('Sudarymas'),
              route: 'nuomaIregistravimasList',
              icon: 'mdi-account-cash-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role(['EL_JA', 'EL_igaliotinis', 'EL_igaliojimas_nuoma']),
            },
            {
              meniuId: 146,
              title: this.$t('Nutraukimas'),
              route: 'nuomaNutraukimasList',
              icon: 'mdi-account-cancel-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role(['EL_JA', 'EL_igaliotinis', 'EL_igaliojimas_nuoma']),
            },
            {
              meniuId: 147,
              title: this.$t('Išregistravimas pasibaigus terminui'),
              route: 'nuomaIsregistravimasList',
              icon: 'mdi-account-remove-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role(['EL_JA', 'EL_igaliotinis', 'EL_igaliojimas_nuoma']),
            },
          ],
        },
        {
          groupTitle: this.$t('Panaudos sutartis'),
          prasymaiList: [
            {
              meniuId: 148,
              title: this.$t('Sudarymas'),
              route: 'panaudaIregistravimasList',
              icon: 'mdi-book-check-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_panauda',
                ]),
            },
            {
              meniuId: 152,
              title: this.$t('Nutraukimas'),
              route: 'panaudaNutraukimasList',
              icon: 'mdi-book-cancel-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_panauda',
                ]),
            },
            {
              meniuId: 153,
              title: this.$t('Išregistravimas pasibaigus terminui'),
              route: 'panaudaIsregistravimasList',
              icon: 'mdi-book-remove-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_panauda',
                ]),
            },
          ],
        },
        {
          groupTitle: this.$t('Subnuomos sutartis'),
          prasymaiList: [
            {
              meniuId: 151,
              title: this.$t('Sudarymas'),
              route: 'subnuomaIregistravimasList',
              icon: 'mdi-file-document-multiple-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_subnuomos',
                ]),
            },
            {
              meniuId: 154,
              title: this.$t('Nutraukimas'),
              route: 'subnuomaNutraukimasList',
              icon: 'mdi-file-cancel-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_subnuomos',
                ]),
            },
            {
              meniuId: 155,
              title: this.$t('Išregistravimas pasibaigus terminui'),
              route: 'subnuomaIsregistravimasList',
              icon: 'mdi-file-remove-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_subnuomos',
                ]),
            },
          ],
        },
        {
          groupTitle: this.$t('Preliminarioji sutartis'),
          prasymaiList: [
            {
              meniuId: 156,
              title: this.$t('Sudarymas'),
              route: 'preliminariIregistravimasList',
              icon: 'mdi-cloud-check-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_preliminari',
                ]),
            },
            {
              meniuId: 157,
              title: this.$t('Nutraukimas'),
              route: 'preliminariNutraukimasList',
              icon: 'mdi-cloud-cancel-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_preliminari',
                ]),
            },
            {
              meniuId: 158,
              title: this.$t('Išregistravimas pasibaigus terminui'),
              route: 'preliminariIsregistravimasList',
              icon: 'mdi-cloud-remove-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) && !this.role(['EL_igaliotinis'])) ||
                this.role([
                  'EL_JA',
                  'EL_igaliotinis',
                  'EL_igaliojimas_preliminari',
                ]),
            },
          ],
        },
        {
          groupTitle: this.$t('NTR duomenys apie asmens turimą žemę'),
          groupH2: true,
          prasymaiList: [
            {
              meniuId: 159,
              redirect: 'pazymosZemesUkio',
              title: this.$t('Pažyma apie žemės ūkio paskirties žemę'),
              route: 'pazymosZemesUkio',
              icon: 'mdi-tractor-variant',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) &&
                  this.roleOr(['EL_PAZYMA', 'EL_igaliojimas_pazyma'])),
            },
            {
              meniuId: 159,
              redirect: 'pazymosMiskuUkio',
              title: this.$t('Pažyma apie miškų ūkio paskirties žemę'),
              route: 'pazymosMiskuUkio',
              icon: 'mdi-forest-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) &&
                  this.roleOr(['EL_PAZYMA', 'EL_igaliojimas_pazyma'])),
            },
            {
              meniuId: 160,
              title: this.$t('Žemės sklypo planas'),
              route: 'pazymosZemesSklypas',
              icon: 'mdi-map-outline',
              roles:
                (this.role(['EL_FA']) && !this.role(['EL_JA'])) ||
                (this.role(['EL_JA']) &&
                  this.roleOr(['EL_SKLYPAS', 'EL_igaliojimas_sklypas'])),
              hide: !this.showZemesSklypas,
            },
          ],
        },
      ]
    },
    paslaugosFiltered() {
      return this.paslaugosList.filter(paslauga => {
        paslauga.tooltip = `NtrPaslaugos. ${paslauga.groupTitle}. Meniu. Anotacija`
        paslauga.prasymaiList = paslauga.prasymaiList.filter(prasymas => {
          return !prasymas.hide && prasymas.roles && prasymas.meniuId > 0
        })
        return !paslauga.hide && paslauga.prasymaiList.length > 0
      })
    },
    showMainTitle() {
      return (
        this.paslaugosFiltered.filter(paslauga => {
          return !paslauga.groupH2
        }).length > 0
      )
    },
    showZemesSklypas() {
      return this.zemes_sklypas_ijungtas
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true

      this.$axios
        .get(`ntrpaslaugos/prasymai`)
        .then(res => {
          this.zemes_sklypas_ijungtas = res.data.zemes_sklypas_ijungtas
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    gotoLocal(route) {
      this.$router.push({ name: route })
    },
    gotoPrasymas(prasymas) {
      if (this.isLocal || this.isTest) {
        this.$router.push({ name: prasymas.route })
        return
      }

      if (prasymas.redirect) {
        this.$store
          .dispatch('savitarnaRedirect', prasymas.redirect)
          .then(this.gotoSavitarna(prasymas))
        return
      }
      this.gotoSavitarna(prasymas)
    },
    gotoSavitarna(prasymas) {
      window.location.href = `${this.savitarnaPrefix}goto.do?menuId=${prasymas.meniuId}`
    },
    showAprasymas(tipas) {
      this.paslaugaAprasymas = tipas
    },
    hideAprasymas() {
      this.paslaugaAprasymas = null
      this.$store.dispatch('activeTooltip', '')
    },
  },
}
</script>
<style lang="scss" scoped>
.prasymas-icon {
  height: 100%;

  &:hover {
    cursor: pointer;
    background: #e5e5e5;
  }
}
</style>
